import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { GoogleMapsService } from '../services/google-maps.service';
import { MenuService } from "../services/menu.service";
import { ModalFormsService } from "../services/modal-forms.service";
import { SignalRService } from '../services/signalr.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [GoogleMapsService]
})
export class AppComponent {
  title = 'bolt';
  collapsedMenu = this.menuService.collapsedMenu;
  isExpandedWideRoute$: Observable<boolean> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => this.router.url.includes('/document/') || this.router.url.includes('/annual-statement/') || this.router.url.includes('/superuser/edge-transactions'))
  );

  isGuestUser$: Observable<boolean>  = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(() => this.router.url.includes('/guest/'))
  );

  constructor(
    private authService: AuthService,
    private menuService: MenuService,
    private router: Router,
    private modalFormsService: ModalFormsService,
    private googleMapsService: GoogleMapsService,
    private signalRService: SignalRService
  ) {
    void this.googleMapsService.loadApi();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.modalFormsService.closeAllFormsModals());

    if (this.authService.isAuthenticated) {
      this.signalRService.startConnection().subscribe({
        next: () => {
          console.log('SignalR connection successfully started');
        },
        error: (error) => {
          console.error('Failed to start SignalR connection:', error);
        },
      });
    }
  }

  public get isAuthenticated() {
    return this.authService.isAuthenticated;
  }
}
